// extracted by mini-css-extract-plugin
export default {"wrapper":"SortPanel_wrapper__9WBI9","searchBox":"SortPanel_searchBox__YsIVh"};